/**
 * DocumentSetCreatedAt
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import FormattedDate from 'components/FormattedDate';

// Selectors
import { makeSelectDocumentSetValue } from 'services/documentSets/selectors';

interface Props {
    createdAt?: string;
}

export class DocumentSetCreatedAt extends React.PureComponent<Props> {
    render() {
        const { createdAt } = this.props;
        return <FormattedDate value={createdAt} format="MMM D" />;
    }
}

const mapStateToProps = createStructuredSelector({
    createdAt: makeSelectDocumentSetValue('createdAt')
});

export default connect(mapStateToProps)(DocumentSetCreatedAt);
